//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../Features/Features.SelectFeature.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"FlipDirection",1,0],[1,"MappingFeature",0,"Features.SelectFeature",0],[0,"Point",1,"Point",0]],[[["matrix"],"UpdateCsys",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Weld.JointmarkPointsBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.JointmarkPointsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.JointmarkPointsBuilder.PointPosition = Object.freeze({
    "None" : "None", "MovedAlongGuide" : "MovedAlongGuide", "MovedOffGuide" : "MovedOffGuide"});

export default SPLM;